"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const modelInfoModal_1 = require("../../../../layouts/modelInfoModal");
const react_spinners_1 = require("react-spinners");
const react_router_dom_1 = require("react-router-dom");
const icons_1 = require("../../../../utils/icons");
const api_1 = require("../../../../utils/api");
const SearchBar_1 = require("../../../../utils/SearchBar");
const style_1 = tslib_1.__importDefault(require("../../../../utils/style"));
const themes_1 = require("../../../../utils/themes");
require("../../../../App.css");
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
const permission_1 = require("src/app/permission");
const Dashboard = () => {
    const styleLocal = style_1.default();
    const history = react_router_dom_1.useHistory();
    const [loading, setLoading] = react_1.useState(false);
    const [isDeletePopupOpen, setIsDeletePopupOpen] = react_1.useState(false);
    const [snackbarOpen, setSnackbarOpen] = react_1.useState(false);
    const [snackbarMessage, setSnackbarMessage] = react_1.useState("");
    const [snackbarType, setSnackbarType] = react_1.useState("");
    const [allModels, setAllModels] = react_1.useState([]);
    const [availableModels, setAvailableModels] = react_1.useState([]);
    const [modalOpen, setModalOpen] = react_1.useState(false);
    const [projectInfo, setProjectInfo] = react_1.useState({});
    const [savedDetails, setSavedDetails] = react_1.useState({});
    const [description, setDescription] = react_1.useState("");
    const [filterModalOpen, setFilterModalOpen] = react_1.useState(false);
    const [selectedProblemType, setSelectedProblemType] = react_1.useState("all");
    const [anchorEl, setAnchorEl] = react_1.useState(null);
    react_1.useEffect(() => {
        getAllModels();
    }, []);
    const getAllModels = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        const data = {
            userid: js_cookie_1.default.get('USER_ID')
        };
        const availableModelsRes = yield api_1.getAllAvailableModels(data);
        console.log(availableModelsRes);
        const models = availableModelsRes.data.model_info_dashboard;
        setAllModels(models);
        setAvailableModels(models);
        setLoading(false);
    });
    const handleViewPopup = (model) => {
        setProjectInfo(model.performancereport);
        setDescription(model.description);
        const dataInfer = {
            dataformat_for_inference: model.model_info_for_inference.dataformat_for_inference.data,
        };
        setSavedDetails(dataInfer);
        setModalOpen(true);
    };
    const handleEditPopup = (model) => {
        console.log("Not developed, Edit details for:", model);
    };
    const handleDeletePopup = (model) => {
        const modelDetails = {
            problemtype: model.problemtype,
            projectname: model.projectname,
            version_name: model.version_name,
        };
        setProjectInfo(modelDetails);
        setIsDeletePopupOpen(true);
    };
    const cancelDeletePopup = () => {
        setIsDeletePopupOpen(false);
    };
    const deleteModel = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        const deleteModelRes = yield api_1.deleteModelDB(projectInfo);
        console.log(deleteModelRes);
        if (deleteModelRes.data.status === 'success') {
            setSnackbarOpen(true);
            setSnackbarMessage("Model deleted successfully!");
            setSnackbarType("success");
        }
        setIsDeletePopupOpen(false);
        getAllModels();
        setLoading(false);
    });
    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };
    const getModelNameFromPath = (path) => {
        const fileNam1 = path.split("\\").pop();
        const fileName = fileNam1.split("/").pop();
        return fileName.replace(/\.[^/.]+$/, "");
    };
    const changeProblemtype = (value) => {
        switch (value.toLowerCase()) {
            case "regression":
                return "Regression";
            case "eventclassification":
                return "Event Classification";
            case "rootcauseanalysis":
                return "Root Cause Analysis";
            case "anomalydetection":
                return "Anomaly Detection";
            default:
                return value;
        }
    };
    const handleSearch = (e) => {
        const searchValue = e.target.value.toLowerCase();
        console.log(allModels);
        if (searchValue === "") {
            setAvailableModels(allModels);
        }
        else {
            const modelsArray = Object.values(allModels);
            const filteredModels = modelsArray.filter((model) => {
                const projectNameMatch = model.projectname.toLowerCase().includes(searchValue);
                const modelNameMatch = model.model_name.toLowerCase().includes(searchValue);
                return projectNameMatch || modelNameMatch;
            });
            const filteredModelsObject = Object.fromEntries(filteredModels.map((model) => [model.projectname, model]));
            setAvailableModels(filteredModelsObject);
        }
    };
    const handleOpenFilterModal = (event) => {
        setAnchorEl(event.currentTarget);
        setFilterModalOpen(true);
    };
    const handleCloseFilterModal = () => {
        setAnchorEl(null);
        setFilterModalOpen(false);
    };
    const handleApplyFilter = () => {
        console.log("Selected Problem Type:", selectedProblemType);
        if (selectedProblemType === "all") {
            setAvailableModels(allModels);
        }
        else {
            const modelArray = Object.values(allModels);
            const filteredModels = modelArray.filter((model) => {
                return model.problemtype === selectedProblemType;
            });
            const filteredModelsObject = Object.fromEntries(filteredModels.map((model) => [model.projectname, model]));
            setAvailableModels(filteredModelsObject);
        }
        handleCloseFilterModal();
    };
    return (react_1.default.createElement(core_1.ThemeProvider, { theme: themes_1.theme },
        react_1.default.createElement(core_1.Grid, { container: true },
            loading && (react_1.default.createElement("div", { style: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(128, 128, 128, 0.7)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                } },
                react_1.default.createElement(react_spinners_1.PropagateLoader, { color: "#3f51b5" }))),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, style: {
                    textAlign: "center",
                    marginTop: '60px',
                    paddingTop: "20px",
                    paddingBottom: "20px",
                } },
                react_1.default.createElement(core_1.Typography, { variant: "h5", className: styleLocal.mainTitleStyle }, "AUTOML DASHBOARD")),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 }),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 1, lg: 1, style: {
                    textAlign: "right",
                    display: "flex",
                } },
                react_1.default.createElement(SearchBar_1.SearchBar, { placeholder: "Search", onChange: (e) => handleSearch(e) })),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 1, lg: 1, style: { margin: 0 } },
                react_1.default.createElement(core_1.Button, { variant: "outlined", style: {
                        color: "#CECACA",
                        textTransform: "none",
                        border: `0.48px solid #CECACA`,
                        opacity: "1",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "left",
                        fontSize: "14px",
                        width: "105px",
                        height: "30px",
                        lineHeight: "20px",
                        marginLeft: "20px",
                    }, onClick: handleOpenFilterModal },
                    react_1.default.createElement("span", { style: {
                            marginRight: "15px",
                            display: "flex",
                            alignItems: "center",
                            color: "#CECACA",
                        } },
                        react_1.default.createElement(icons_1.FilterIcon, null)),
                    react_1.default.createElement("span", null, "Filter"))),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 8, lg: 8 }),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 }),
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 8, lg: 8 },
                react_1.default.createElement(core_1.TableContainer, { component: core_1.Paper },
                    react_1.default.createElement(core_1.Table, { "aria-label": "root causes table" },
                        react_1.default.createElement(core_1.TableHead, null,
                            react_1.default.createElement(core_1.TableRow, null,
                                react_1.default.createElement(core_1.TableCell, { align: "left", style: { width: '20%', fontWeight: 'bold' } }, "Project Name"),
                                react_1.default.createElement(core_1.TableCell, { align: "left", style: { width: '20%', fontWeight: 'bold' } }, "Model Name"),
                                react_1.default.createElement(core_1.TableCell, { align: "left", style: { width: '20%', fontWeight: 'bold' } }, "Problem Type"),
                                permission_1.hasUserPermission("MODEL_HUB", "VIEW") && (react_1.default.createElement(core_1.TableCell, { align: "right", style: { paddingRight: '48px', width: '40%', fontWeight: 'bold' } }, "Action")))),
                        react_1.default.createElement(core_1.TableBody, null, Object.entries(availableModels).length > 0 ? (Object.entries(availableModels).map(([userid, models]) => {
                            return Object.entries(models).map(([project, modelInfo], index) => {
                                return react_1.default.createElement(core_1.TableRow, { key: index },
                                    react_1.default.createElement(core_1.TableCell, { align: "left" }, modelInfo && modelInfo.projectname && modelInfo.projectname),
                                    react_1.default.createElement(core_1.TableCell, { align: "left" }, modelInfo && modelInfo.model_name ? getModelNameFromPath(modelInfo.model_name) : ''),
                                    react_1.default.createElement(core_1.TableCell, { align: "left" }, modelInfo && modelInfo.problemtype ? changeProblemtype(modelInfo.problemtype) : ''),
                                    react_1.default.createElement(core_1.TableCell, null,
                                        react_1.default.createElement(core_1.Box, { display: "flex", gap: "10px", justifyContent: "flex-end" },
                                            permission_1.hasUserPermission("MODEL_HUB", "VIEW") && (react_1.default.createElement(core_1.IconButton, { size: "small", onClick: () => handleViewPopup(modelInfo), disabled: true },
                                                react_1.default.createElement(icons_1.ViewIcon, null))),
                                            permission_1.hasUserPermission("MODEL_HUB", "EDIT") && (react_1.default.createElement(core_1.IconButton, { size: "small", onClick: () => handleEditPopup(modelInfo), disabled: true },
                                                react_1.default.createElement(icons_1.EditIcon, { stroke: "#707070" }))),
                                            permission_1.hasUserPermission("MODEL_HUB", "DELETE") && (react_1.default.createElement(core_1.IconButton, { size: "small", onClick: () => handleDeletePopup(modelInfo), disabled: true },
                                                react_1.default.createElement(icons_1.TrashIcon, null))))));
                            });
                        })) : (react_1.default.createElement(core_1.TableRow, null,
                            react_1.default.createElement(core_1.TableCell, { colSpan: 4, align: "center" }, "No models available."))))))),
            react_1.default.createElement(core_1.Popover, { open: filterModalOpen, anchorEl: anchorEl, onClose: handleCloseFilterModal, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                } },
                react_1.default.createElement(core_1.Box, { sx: { padding: "16px", width: "auto" } },
                    react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, "Select Problem Type:"),
                    react_1.default.createElement(core_1.RadioGroup, { value: selectedProblemType, onChange: (e) => setSelectedProblemType(e.target.value) },
                        react_1.default.createElement(core_1.FormControlLabel, { value: "all", control: react_1.default.createElement(core_1.Radio, { color: "primary" }), label: "All" }),
                        react_1.default.createElement(core_1.FormControlLabel, { value: "regression", control: react_1.default.createElement(core_1.Radio, { color: "primary" }), label: "Regression" }),
                        react_1.default.createElement(core_1.FormControlLabel, { value: "eventclassification", control: react_1.default.createElement(core_1.Radio, { color: "primary" }), label: "Event Classification" }),
                        react_1.default.createElement(core_1.FormControlLabel, { value: "RootCauseAnalysis", control: react_1.default.createElement(core_1.Radio, { color: "primary" }), label: "RootCause Analysis" }),
                        react_1.default.createElement(core_1.FormControlLabel, { value: "anomalydetection", control: react_1.default.createElement(core_1.Radio, { color: "primary" }), label: "Anomaly Detection" })),
                    react_1.default.createElement(core_1.Box, { sx: { display: 'flex', justifyContent: 'flex-end', marginTop: '16px', marginLeft: "60px" } },
                        react_1.default.createElement(core_1.Button, { className: "ml-btn-cancel", variant: "outlined", onClick: handleCloseFilterModal, style: { margin: "0px 10px 0px 0px", color: "#707070" } }, "Cancel"),
                        react_1.default.createElement(core_1.Button, { className: "ml-form-btn", variant: "contained", onClick: handleApplyFilter, style: { margin: "0px", backgroundColor: "#2A7CED", color: "white" } }, "Apply Filter")))),
            react_1.default.createElement(modelInfoModal_1.ModelInfoModal, { open: modalOpen, onClose: () => setModalOpen(false), type: "viewDashboard", projectInfo: projectInfo, description: description, savedDetails: savedDetails }),
            react_1.default.createElement(core_1.Snackbar, { open: snackbarOpen, autoHideDuration: 3000, onClose: handleCloseSnackbar },
                react_1.default.createElement(lab_1.Alert, { onClose: handleCloseSnackbar, severity: snackbarType, sx: { width: '100%' } }, snackbarMessage)),
            react_1.default.createElement(core_1.Dialog, { open: isDeletePopupOpen, onClose: cancelDeletePopup },
                react_1.default.createElement(core_1.DialogTitle, null, "Confirm Delete"),
                react_1.default.createElement(core_1.DialogContent, null,
                    react_1.default.createElement(core_1.Typography, null,
                        "Are you sure you want to delete the model: ",
                        projectInfo && projectInfo.projectname,
                        "?")),
                react_1.default.createElement(core_1.Box, { sx: { display: 'flex', justifyContent: 'flex-end', padding: '16px' } },
                    react_1.default.createElement(core_1.Button, { className: "ml-btn-cancel", onClick: cancelDeletePopup, color: "primary", style: { marginRight: "8px" } }, "Cancel"),
                    react_1.default.createElement(core_1.Button, { className: "ml-btn-delete", onClick: deleteModel, color: "primary" }, "Delete"))))));
};
exports.default = Dashboard;
exports.FilterGrid = ({ filterGridOpen, handleCloseFilterGrid, selectedProblemType, setSelectedProblemType, handleApplyFilter }) => {
    if (!filterGridOpen)
        return null; // Render nothing if the grid is not open
    return (react_1.default.createElement(core_1.Box, { sx: {
            position: 'fixed',
            top: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1300,
            backgroundColor: 'white',
            boxShadow: 3,
            borderRadius: 2,
            padding: 2,
        } },
        react_1.default.createElement(core_1.Typography, { variant: "h6", gutterBottom: true }, "Filter Models"),
        react_1.default.createElement(core_1.Grid, { container: true, spacing: 2 },
            react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 6 },
                react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, "Select Problem Type:"),
                react_1.default.createElement(core_1.RadioGroup, { value: selectedProblemType, onChange: (e) => setSelectedProblemType(e.target.value) },
                    react_1.default.createElement(core_1.FormControlLabel, { value: "regression", control: react_1.default.createElement(core_1.Radio, { color: "primary" }), label: "Regression" }),
                    react_1.default.createElement(core_1.FormControlLabel, { value: "classification", control: react_1.default.createElement(core_1.Radio, { color: "primary" }), label: "Classification" }),
                    react_1.default.createElement(core_1.FormControlLabel, { value: "clustering", control: react_1.default.createElement(core_1.Radio, { color: "primary" }), label: "Clustering" }),
                    react_1.default.createElement(core_1.FormControlLabel, { value: "anomaly_detection", control: react_1.default.createElement(core_1.Radio, { color: "primary" }), label: "Anomaly Detection" })))),
        react_1.default.createElement(core_1.Box, { sx: { display: 'flex', justifyContent: 'flex-end', marginTop: 2 } },
            react_1.default.createElement(core_1.Button, { onClick: handleCloseFilterGrid, color: "primary", style: { marginRight: "8px" } }, "Cancel"),
            react_1.default.createElement(core_1.Button, { onClick: handleApplyFilter, color: "primary" }, "Apply"))));
};
//# sourceMappingURL=Dashboard.js.map